import { IApplicationState } from '../../types/redux';

export function getSellers(state: IApplicationState) {
  return state.developer.sellers;
}
